import React, { useEffect, useRef } from 'react';
import { useClientSide } from '../../utils/useClientSide';

const TEMPLATE_ID = '54ad5defc6454f065c28af8b';
const BUSINESS_UNIT_ID = '63a2c348695b2472e05aadf8';
const TAG = 'Abrechnung-Direct';

export const TrustBox = () => {
  const ref = useRef(null);
  const isClient = useClientSide();

  useEffect(() => {
    if (typeof window.Trustpilot !== 'undefined' && window.Trustpilot.loadFromElement) {
      // Ensure that both window.Trustpilot and the loadFromElement method are available.
      window.Trustpilot.loadFromElement(ref.current, true);
    }

    return () => {
      if (ref.current && typeof window.Trustpilot !== 'undefined' && window.Trustpilot.remove) {
        // Ensure that both the element, window.Trustpilot, and the remove method are available.
        window.Trustpilot.remove(ref.current);
      }
    };
  }, [isClient]);

  return !isClient ? (
    <></>
  ) : (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="de-DE"
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-height="240px"
      data-style-width="100%"
      data-theme="light"
      data-tags={TAG}
      data-stars="4,5"
      data-review-languages="de"
    >
      <a href="https://de.trustpilot.com/review/techem.com/de/de" target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  );
};
